export const ADD_TOAST_MESSAGE = 'ADD_TOAST_MESSAGE';
export const DELETE_TOAST_MESSAGE = 'DELETE_TOAST_MESSAGE';
